import { useState } from "react";
import "./MitgliederListe.css";
import linkSvg from "../../assets/link.svg";

function MitgliederListe() {
  const mitglieder = [
    {
      name: "Behrens, Alfred",
      link: "	http://de.wikipedia.org/wiki/Alfred_Behrens",
    },
    {
      name: "Blockhaus, Thomas",
      link: "http://de.wikipedia.org/wiki/Thomas_Blockhaus",
    },
    { name: "Brod, Oliver", link: "http://www.oliverbrod.de/" },
    { name: "Brusilovsky, Noam", link: "http://www.noam-brusilovsky.com/" },
    {
      name: "Buhlert, Klaus",
      link: "http://de.wikipedia.org/wiki/Klaus_Buhlert",
    },
    { name: "Dickmeiß, Cordula", link: "" },
    { name: "Elstner, Alice", link: "" },
    {
      name: "Fritsch, Götz  †",
      link: "http://de.wikipedia.org/wiki/Götz_Fritsch",
    },
    { name: "Haug, Helgard", link: "https://www.rimini-protokoll.de/" },
    { name: "Ginzler, Mark", link: "" },
    { name: "Grehn, Kai", link: "http://www.kaigrehn.de/" },
    {
      name: "Heindel, Martin",
      link: "http://www.suhrkamp.de/autoren/martin_heindel_6632.html",
    },
    { name: "Hildebrandt, Silke  †", link: "" },
    { name: "Hüster, Henri", link: "https://www.henrihuester.com/" },
    { name: "Janssen, Ulrike", link: "" },
    { name: "Kamphans, Simon", link: "https://www.hinhoerfaktor.de/" },
    {
      name: "Koppelmann. Leonhard",
      link: "http://de.wikipedia.org/wiki/Leonhard_Koppelmann",
    },
    { name: "Krewer, Harald", link: "http://www.speaklow.de" },
    {
      name: "Krogmann, Hans Gerd †",
      link: "http://de.wikipedia.org/wiki/Hans_Gerd_Krogmann",
    },
    { name: "Kubli, Thom", link: "http://www.thomkubli.de" },
    { name: "Kuner, Jean-Claude", link: "" },
    {
      name: "Lorentz, Judith",
      link: "http://de.wikipedia.org/wiki/Judith_Lorentz",
    },
    { name: "Meerkötter, Barbara", link: "" },
    {
      name: "Meinetsberger, Andreas",
      link: "https://de.wikipedia.org/wiki/Andreas_Meinetsberger",
    },
    {
      name: "Nagel, Christine",
      link: "https://de.wikipedia.org/wiki/Christine_Nagel_(Hörspielautorin)",
    },
    { name: "Partenzi, Felix", link: "http://caruccio.de" },
    { name: "Petri, Kirstin", link: "" },
    { name: "Petschinka, Eberhard", link: "http://www.krok.cc" },
    { name: "Plensat, Barbara", link: "http://barbara-plensat.de" },
    { name: "Putz, Elisabeth", link: "" },
    {
      name: "Rindfleisch, Wolfgang",
      link: "http://de.wikipedia.org/wiki/Wolfgang_Rindfleisch",
    },
    { name: "Schoen, Robert", link: "http://www.schoenerlauschen.de/" },
    { name: "Schuhmacher, Alexander", link: "http://www.radioplayers.de" },
    {
      name: "Seesko, Wolfgang",
      link: "http://de.wikipedia.org/wiki/Wolfgang_Seesko",
    },
    { name: "Steckel, Ronald †", link: "" },
    { name: "Sturm, Oliver", link: "http://www.gebetomat.de/" },
    { name: "Trocker, Anouschka", link: "" },
  ];

  const list = mitglieder.map((mitglied, i) => (
    <tr key={i} className="mitgliederListLi">
      <td className="mitgliederListName">{mitglied.name}</td>
      <td>
        <a href={mitglied.link} target="blank" className="linkText">
          {mitglied.link}
        </a>
        {mitglied.link ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <a href={mitglied.link} target="blank">
              <img src={linkSvg} className="linkSvg"></img>
            </a>
          </div>
        ) : (
          <></>
        )}
      </td>
    </tr>
  ));

  return (
    <div className="mitgliederListDiv">
      <table className="mitgliederListUl">
        <tbody>{list}</tbody>
      </table>
    </div>
  );
}

export default MitgliederListe;
